<template>
  <div class="box">
    <div class="newsinfo">
      <div class="top">
        <router-link to="/">首页</router-link>><span>{{title}}<span v-if="title!='联系我们'">>文章正文</span></span>
      </div>
      <div class="title">
        <h2>{{articles.title}}</h2>
        <div>
          <span class="addtime">{{articles.addtime|filterDate}}</span>
          <span>浏览：{{articles.artvisits}}</span>
        </div>
      </div>
      <div class="contentinfo" v-html="articles.contentHtml"></div>
    </div>
  </div>
</template>

<script>
import { getNewsInfo, getNewsViewsZero } from '@/request/get'
export default {
  name: "NewsInfo",
  components: {
  },
  data() {
    return {
      plateId: this.$route.params.plateId || '',
      articleId: this.$route.params.articleId || '',
      articles: {
        addtime: "",
        title:"",
        description:"",
        keywords:""
      }
    }
  },
  filters: {
    filterDate(date) {
      return date.slice(0, 10);
    }
  },
  computed: {
    title() {
      let { plates } = this.$store.state;
      let arrs = plates.filter(item => item.uuid == this.plateId)
      return arrs.length === 0 ? "未配置" : arrs[0].name
    }
  },
  created() {
    this.getNewsInfo();
  },
  mounted() {
    this.toTop();
  },
  methods: {
    async getNewsInfo() {
      if (this.articleId === "000000") {
        let res = await getNewsViewsZero(this.plateId);
        let articles = res.data;
        if (articles.length == 0) {
          return;
        } 
        this.articleId = articles[0].uuid;
      }
      let result = await getNewsInfo(this.articleId);
      this.articles = result.data;
      if (!this.articles.addtime) {
        let addtime = this.articles.createdAt;
        let date = new Date(addtime);
        this.articles.addtime = `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${("00" + date.getHours()).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${("00" + date.getSeconds()).slice(-2)}`
      }
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
.box{
  position: relative;
  width: 100%;
  background-color: #fff;
}
.newsinfo{
  position: relative;
  width: 1200px;
  /* min-height: 1245px; */
  margin: 0 auto;
  overflow: hidden;
}
.newsinfo>.top{
  position: relative;
  margin-top: 27px;
  height: 14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 14px;
}
.newsinfo>.title{
  position: relative;
  height: 22px;
  padding: 49px 0 61px;
  border-bottom: 1px solid #EFEFEF;
  margin-bottom: 42px;
}
.newsinfo>.title>h2{
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #306BCD;
  line-height: 22px;
  text-align: center;
}
.newsinfo>.title>div {
  position: absolute;
  right: 5px;
  bottom: 14px;
}
.newsinfo>.title>div>span{
  height: 14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #BDBDBD;
  line-height: 14px;
}
.newsinfo>.title>div>span.addtime{
  display: inline-block;
  padding-right: 47px;
}
.newsinfo>.contentinfo{
  margin-left:8px;
  width: 1162px;
  min-height: 463px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
}
</style>
